import { EWidgets } from "@/features/financas/views/Indicadores/@types/enums";
import PreferenciasTemplate from "./strategy/PreferenciasTemplate";
import { IFiltrosGerais } from "../../@types/type";

export default class PreferenciasFiltrosGerais extends PreferenciasTemplate<IFiltrosGerais> {
  constructor() {
    super(EWidgets.Preferencias);
  }
}
